import io from 'socket.io-client';

var NotificationSocket;

const END_URL = process.env.REACT_APP_SOCKET_URL;

const connectSocket = () => {
    const credentials = {
        AccessToken: localStorage.getItem('accessToken')
    };

    NotificationSocket = io(END_URL, {
        transports: ['websocket'],
        query: credentials,
        autoConnect: false,
        reconnection: true,
        reconnectionAttempts: 5
    });
};

export { connectSocket, NotificationSocket };
